module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_vm._v("Bet Sizing Calculator")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "12px"
    }
  }, [(_vm.errors.has('bankroll')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Bankroll is required")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('odds')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Enter Odds in American Format")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('edge')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid Edge number")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "float": "left",
      "width": "100%"
    }
  }, [_c('form', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "bankroll"
    }
  }, [_vm._v("Bankroll:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankroll),
      expression: "bankroll"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "bankroll",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "type": "number",
      "name": "bankroll",
      "maxlength": "10",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.bankroll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankroll = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "odds"
    }
  }, [_vm._v("American Odds:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odds),
      expression: "odds"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|american_odds'),
      expression: "'required|american_odds'"
    }],
    attrs: {
      "type": "text",
      "name": "odds",
      "maxlength": "10",
      "data-vv-delay": "4000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.odds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odds = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "edge"
    }
  }, [_vm._v("Edge:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edge),
      expression: "edge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    attrs: {
      "type": "text",
      "name": "edge",
      "maxlength": "5",
      "data-vv-delay": "4000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.edge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "block"
    }
  }, [_c('label', {
    attrs: {
      "for": "risk"
    }
  }, [_vm._v("Risk Tolerance:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMultiplier),
      expression: "selectedMultiplier"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "risk"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.multiplierChange]
    }
  }, _vm._l((_vm.multipliers), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "size-results"
  }, [(_vm.showOptimalBetSize) ? _c('p', {
    staticStyle: {
      "padding-bottom": "6px"
    }
  }, [_vm._v("Optimal Bet Size: $" + _vm._s(_vm.optimal.betSize))]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.optimal.percentage) + " of Bankroll")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Calculate",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.calculate($event)
      }
    }
  })])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a09b3b8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Size.vue
// module id = 305
// module chunks = 1